import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWireHistoryList extends Layout {
    searchpanelSP: SearchPanel;
    sourcePostedWire: DataSource;
    switchVoided: Switch;
    tableWireFundsProcessing: Table;
    textboxCheckNumber: Textbox;
    textboxDriverIdSearch: Textbox;
    textboxFuelInterfaceId: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxPayeeIdSearch: Textbox;
    textboxTransDateTimeSearch: Textbox;
    textboxUserId: Textbox;
    textboxVoidDate: Textbox;
    textboxWirecodeid: Textbox;
}
